import store from '@/store';
import {VueConstructor} from 'vue/types/vue';

export default {
  install(Vue: VueConstructor) {
    Vue.mixin({
      computed: {
        $PL() {
          return {
            ...store.state.billing.limits
          }
        }
      }
    });
  }
}
